<template>
  <div class="AddressPage">
    <MainPageHeader v-if="!isAndroidContext"/>
    <div v-if="productDetails" :class="{'android-content': isAndroidContext}" class="content">
      <header v-if="!isAndroidContext" class="main-header">
        <p v-if="getProductId === '3' || getProductId === '4'" class="font-size-middle">Krok 2 z 3</p>
        <p v-else class="font-size-middle">Krok 2 z 3</p>
      </header>
      <div v-if="!isAndroidContext" class="divider"/>
      <div v-if="!isAndroidContext" class="text-header">
        <h1 class="font-size-big">Dodaj lub zaakceptuj adres</h1>
        <p>Adres możesz dowolnie edytować w zakładce
          <router-link class="man-acc" to="/edit-my-account">Edytuj konto.</router-link>
        </p>
      </div>
      <section class="section section-1" v-if="account != null">
        <div class="panels">
          <AddressPanel
              v-if="account"
              :address="shippingAddress"
              :editable="isPanelEditable('shippingAddress')"
              :title="`Adres dostawy`"
              :isLoading="isLoadingAccountShipping"
              class="address-panel"
              @edit="editAddress('shippingAddress')"
              @save="saveChanges('shippingAddress')"
          />
          <div class="invoice-question">
            <span class="title font-size-middle">Potrzebujesz faktury do zamówienia?</span>
            <span class="description font-size-middle">
              Jeśli podczas zakupu nie uzupełnisz danych do faktury, to dokument
              sprzedaży zostanie wystawiony na Dane odbiorcy przesyłki.
            </span>
            <div class="want-invoice-container">
              <div>
                <Checkbox
                  :checked="isBillingAddressVisible"
                  :disabled="false"
                  :highlightError="false"
                  @click="toggleShowBillingAddress()"
                />
              </div>
              <span class="want-invoice-description font-size-middle"
              >Zaznacz jeżeli chcesz fakturę</span
              >
            </div>
          </div>
          <InvoiceAddressPanel
              v-if="isBillingAddressVisible"
              :address="billingAddress"
              :editable="isPanelEditable('billingAddress')"
              :emptyAddress=false
              :isLoading="isLoadingAccountBilling"
              :title="`Adres do faktury`"
              class="invoice-billing-address"
              @edit="editAddress('billingAddress')"
              @save="saveChanges('billingAddress')"
          />
        </div>
      </section>
      <section class="section section-1" v-else>
        <div class="panels">
          <AddressPanel
              :editable="false"
              :loading=true
              :title="`Adres dostawy`"
              class="address-panel"
          />
          <div class="invoice-question">
            <span class="title font-size-middle">Potrzebujesz faktury do zamówienia?</span>
            <span class="description font-size-middle">
              Jeśli podczas zakupu nie uzupełnisz danych do faktury, to dokument
              sprzedaży zostanie wystawiony na Dane odbiorcy przesyłki.
            </span>
            <div class="want-invoice-container">
              <div>
                <Checkbox
                  :checked="isBillingAddressVisible"
                  :disabled="false"
                  :highlightError="false"
                  @click="toggleShowBillingAddress"
                />
              </div>
              <span class="want-invoice-description font-size-middle"
              >Zaznacz jeżeli chcesz fakturę</span
              >
            </div>
          </div>
        </div>
      </section>
    </div>
    <TabFooter
        :buttonEnabled="buttonStatus()"
        :name="getProductDetails.name"
        :period="getProductDetails.period"
        :price="productDetails.price"
        :quantity="productDetails.quantity"
        @buttonClicked="proceedToPaymentPage"
    />
    <PageNotFound v-if="loadError" :message="loadError"/>
    <ContentLoader v-if="!productDetails"/>
  </div>
</template>

<script>
import MainPageHeader from '../components/MainPageHeader.vue'
import PageNotFound from '../components/PageNotFound.vue'
import ContentLoader from '../components/ContentLoader.vue'
import TabFooter from '../components/TabFooter.vue'
import { getAuthService } from '../services/authService'
import AddressPanel from '@/components/accountView/AddressPanel'
import Checkbox from '@/components/input/Checkbox'
import InvoiceAddressPanel from '@/components/accountView/InvoiceAddressPanel'
import { getAccountService } from '@/services/accountService'
import { limitView } from '@/helpers/permissionHelper'
import { SUBUSER, USER } from '@/types/role.types'
import { productDatabase } from '@/services/mock/productDatabase'
import '../../node_modules/placeholder-loading/src/scss/placeholder-loading.scss'
import { getAndroidContext } from '@/services/sessionProps'

export default {
  name: 'AddressPage',
  components: {
    MainPageHeader,
    PageNotFound,
    ContentLoader,
    TabFooter,
    AddressPanel,
    Checkbox,
    InvoiceAddressPanel,
  },

  data () {
    return {
      productDetails: {
        key: '',
        name: '',
        price: '',
        period: '',
        quantity: '',
      },
      loadError: null,
      loggedInEmail: null,
      isLoadingAccountShipping: false,
      isLoadingAccountBilling: false,
      isBillingAddressVisible: false,
      account: null,
      copyAccount: null,
      addressesEditModes: {},
      shippingAddress: null,
      billingAddress: null,
      isLoading: true,
      invoiceDataIsReady: false,
      isAndroidContext: false,
    }
  },
  async mounted () {
    window.scrollTo(0,0);
    if(this.$route.params.product) {
      this.productDetails = this.$route.params.product
    } else {
      this.$router.replace({ name: 'mainPage' })
    }
    this.isAndroidContext = getAndroidContext().isAndroidContext()

    if(document.querySelector('#chat-application') && this.isAndroidContext) {
      document.querySelector('#chat-application').classList.add('hidden-chat')
    }

    if (await limitView(this.$router, [USER, SUBUSER])) {
      return
    }
    this.account = await getAccountService().getAccountWithAddresses(
        await getAuthService().getLoggedInKey()
    )

    this.copyAccount = JSON.parse(JSON.stringify(this.account))

    this.isBillingAddressVisible = this.account.billingAddress.invoiceWanted
    this.billingAddress = this.account.billingAddress || null
    this.shippingAddress = this.account.shippingAddress || null

    if (this.shippingAddress.street.length === 0) {
      this.addressesEditModes = { 'shippingAddress': true }
    }

    if (this.account.shippingAddress.city.length !== 0) {
      this.isLoading = false
      this.invoiceDataIsReady = true
    }

    if (this.account === null) {
      this.loadError = 'The account with the specified id doesn\'t exist'
    }

    if (!this.billingAddress.name && !this.billingAddress.companyName) {
      this.addressesEditModes.billingAddress = true
    }

    await (async () => {
      const [loggedInEmail] = await Promise.all([
        getAuthService().getLoggedInEmail(),
      ])

      this.loggedInEmail = loggedInEmail
      if (this.loggedInEmail == null) {
        this.$router.replace({
          name: 'logInPage',
        })
      }
    })()
  },

  computed: {
    getProductId() {
      return this.$route.params.productId
    },

    getProductDetails() {
      return productDatabase[this.getProductId]
    },
  },

  beforeDestroy() {
    document.querySelector('#chat-application').classList.remove('hidden-chat')
  },

  methods: {
    async editAddress (index) {
      if (this.isPanelEditable(index)) {
        this.invoiceDataIsReady = true
      } else {
        this.invoiceDataIsReady = false
      }
      this.addressesEditModes = {
        [index]: !this.addressesEditModes[index],
      }
    },
    async saveChanges (dataType) {
      let status
      this.invoiceDataIsReady = true
      if (dataType === 'shippingAddress') {
        this.isLoadingAccountShipping = true
        if (!this.account.shippingAddress.hydraId) {
          this.account.shippingAddress.hydraId = null
          status = await getAccountService().updateShippingAddress(this.account)
        }
        status = await getAccountService().updateShippingAddress(this.account)
      } else {
        this.isLoadingAccountBilling = true
        if (!this.account.billingAddress.hydraId) {
          this.account.billingAddress.hydraId = null
          status = await getAccountService().updateBillingAddress(this.account)
        }
        this.account.billingAddress.invoiceWanted = true
        status = await getAccountService().updateBillingAddress(this.account)
      }

      if (status) {
        this.addressesEditModes[dataType] = !this.addressesEditModes[dataType]
        this.copyAccount = JSON.parse(JSON.stringify(this.account))
      }

      if (!this.isBillingAddressVisible) {
        this.account.billingAddress.name = this.account.shippingAddress.name
        this.account.billingAddress.surname = this.account.shippingAddress.surname
        this.account.billingAddress.street = this.account.shippingAddress.street
        this.account.billingAddress.postCode = this.account.shippingAddress.postCode
        this.account.billingAddress.city = this.account.shippingAddress.city
        this.account.billingAddress.NIP = ''
        this.account.billingAddress.companyName = ''
        this.account.billingAddress.invoiceWanted = false
        this.isLoading = false

        if(!this.account.billingAddress.hydraId) {
          this.account.billingAddress.hydraId = null
        }

        this.isLoadingAccountShipping = false

        await getAccountService().updateBillingAddress(this.account);
      }
      this.isLoadingAccountShipping = false
      this.isLoadingAccountBilling = false
    },
    async toggleInvoice () {
      this.copyAccount.billingAddress.invoiceWanted = !this.copyAccount.billingAddress.invoiceWanted
      if (this.isBillingAddressVisible === true && this.billingAddress.street.length === 0) {
        this.invoiceDataIsReady = false
      } else {
        this.invoiceDataIsReady = true
      }

      await getAccountService().updateBillingAddress(this.copyAccount)
    },
    isAdressEmpty () {
      if (this.account !== null) {
        if (this.account.shippingAddress.city.length === 0) {
          return true
        }
      } else return false
    },
    isPanelEditable (index) {
      return !!this.addressesEditModes[index]
    },
    toggleShowBillingAddress () {
      this.isBillingAddressVisible = !this.isBillingAddressVisible
      if (!this.billingAddress.name && !this.billingAddress.companyName) {
        this.addressesEditModes.billingAddress = true
      }
      this.toggleInvoice()
    },
    async setBillingAddress() {
      let hydra
      if (this.account.billingAddress.hydraId) {
        hydra = this.account.billingAddress.hydraId
      } else {
        hydra = null
      }
      const account = {
        key: this.account.key,
        billingAddress: {
          name: this.account.shippingAddress.name,
          surname: this.account.shippingAddress.surname,
          street: this.account.shippingAddress.street,
          postCode: this.account.shippingAddress.postCode,
          city: this.account.shippingAddress.city,
          invoiceWanted: false,
          NIP: '',
          companyName: '',
          hydraId: hydra,
        }
      }
      await getAccountService().updateBillingAddress(account)
    },
    async proceedToPaymentPage () {
      if (this.account.shippingAddress.city.length === 0) {
        return
      }
      if(!this.isBillingAddressVisible) {
        await this.setBillingAddress()
      }

      if (this.loggedInEmail != null) {
        this.$router.push({
          name: 'payment',
          params: { product: this.productDetails, productId: this.getProductId },
        })
      } else {
        this.$router.push({
          name: 'logInPage'
        })
      }
    },
    buttonStatus () {
      if (this.isLoading) {
        return false
      } else {
        if (!this.invoiceDataIsReady) {
          return false
        }
        return true
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.TabPage {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  grid-template-areas:
    "header"
    "content"
    "footer";
  min-height: 100vh;
}


.MainPageHeader {
  grid-area: header;
}

.Footer {
  grid-area: footer;
}

.content {
  grid-area: content;

  padding: 0 20px;
  margin-top: 140px;
  margin-bottom: 100px;

  // Mobile style
  @media (max-width: $phone-max-width) {
    margin-top: 100px;
  }

  header.main-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 auto;
    max-width: 1300px;

    p {
      font-weight: bold;
    }

    h1 {
      margin-left: 20px;
      color: $primary;
    }
  }

  .text-header {
    padding: 20px 0;
    margin-bottom: 20px;
    text-align: center;
    color: white;

    // Mobile style
    @media (max-width: $phone-max-width) {
      padding: 10px 0;
      margin-bottom: 20px;
    }

    h1 {
      color: $primary;
      margin-bottom: 0;
    }

    margin-bottom: 0;

    h2 {
      color: $primary;
      font-weight: normal;
    }

    .man-acc {
      text-decoration: none;
      color: #d6ae5d;
    }


    // Mobile style
    @media (max-width: $phone-max-width) {

      padding: 10px 0;
      margin-bottom: 20px;

      h1 {
        margin: 0;
      }
    }
  }

  .section {
    display: block;
    margin: 0 auto;
    margin-bottom: 30px;
    padding: 20px 30px;
    max-width: 1000px;
    border: 1px solid #aaa;

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      p {
        margin: 0;
        color: #ddd;
      }

      .image-placeholder {
        width: 40px;
        height: 30px;
        background-color: white;
      }
    }

    .panels {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto auto;
      grid-gap: 20px 100px;
      margin: 0 auto;

      .invoice-question {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto 20px auto 20px 1fr;
        grid-column-start: 1;

        .title {
          grid-row-start: 1;
          color: darken(white, 18%);
        }

        .description {
          grid-row-start: 3;
          width: 350px;
          color: grey;
          letter-spacing: -0.1px;
        }

        .want-invoice-container {
          grid-row-start: 5;
          display: grid;
          grid-template-columns: auto 20px 1fr;

          .want-invoice-description {
            grid-column-start: 3;
            color: darken(white, 15%);
          }
        }
      }

      .invoice-billing-address {
        grid-column-start: 2;
        grid-row: 1/3;
      }

      .address-panel {
        grid-column-start: 1;
      }
    }
  }

  .big-button {
    display: block;
    margin: 20px auto;
    margin-top: 60px;
    min-width: 400px;

    // Mobile style
    @media (max-width: $phone-max-width) {
      width: 100%;
      min-width: unset;
    }
  }
}

.android-content {
  margin-top: 30px;
}

.section-1 {
  border-color: $primary;
}

.divider {
  border-bottom: 1px solid #aaa;
}

@media only screen and (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {
  .content {
    .section {
      .panels {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto auto;
        grid-gap: 50px 200px;
        width: 100%;

        .AddressPanel {
          &.billing-address {
            order: initial;
          }
        }

        .invoice-billing-address {
          order: initial;
          grid-column-start: 1;
          grid-row-start: 3;
        }

        .invoice-question {
          grid-column: 1;
          grid-row-start: 2;

          .description {
            width: auto;
            padding-right: 10px;
          }
        }

        .invoice-billing-address {
          grid-column-start: 1;
          grid-row: auto;
        }

        .address-panel {
          grid-row-start: 1;
        }
      }
    }
  }
}

@media only screen and (max-width: $phone-max-width) {
  .content {
    .section {
      .panels {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto auto;
        grid-gap: 50px 200px;
        width: 100%;

        .AddressPanel {
          &.billing-address {
            order: initial;
          }
        }

        .invoice-billing-address {
          order: initial;
          grid-column-start: 1;
          grid-row-start: 3;
        }

        .invoice-question {
          grid-column: 1;
          grid-row-start: 2;

          .description {
            width: auto;
            padding-right: 10px;
          }
        }

        .invoice-billing-address {
          grid-column-start: 1;
          grid-row: auto;
        }

        .address-panel {
          grid-row-start: 1;
        }
      }
    }
  }
}

@media only screen and (max-width: 425px) {
  .section.section-1 {
    padding: 20px 15px
  }
}

@media (max-width: $phone-max-width) {
  .section.section-1 {
    padding: 0;
    border: none;
  }
}
</style>
